import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Async } from '../../../../components/AsyncProvider';
import { Loading } from '../../../../components/Loading/index';
import { IAsyncData } from '../../../../models';
import { IApplicationState } from '../../../../store/models';
import { Container } from '../../../Layout/components/Container';
import { ISingleProject } from '../../models';
import { getProject } from '../../store/actions';
import { ProjectComponents } from './components';
import { ProjectHeader } from './header';
import { NextProjects } from './nextProjects';

import './index.scss';

interface IParams {
    slug: string;
}

export const SingleProject: React.FC = () => {
    const { slug } = useParams<IParams>();
    const dispatch = useDispatch();
    const projectBranch = useSelector<IApplicationState, IAsyncData<ISingleProject>>((state: IApplicationState) => state.projects.project);

    React.useEffect(
        () => {
            dispatch(getProject(slug));
        },
        [dispatch, slug]
    );

    return (
        <Container>
            <Async
                branch={projectBranch}
                deps={[projectBranch, slug]}
                successRender={(data) => {
                    const {
                        project: {
                            description,
                            name: projectName,
                            components,
                        },
                        next_projects
                    } = data;

                    return (
                        <>
                            <ProjectHeader
                                name={projectName}
                                description={description}
                            />
                            <ProjectComponents components={components} />
                            <NextProjects projects={next_projects} />
                        </>
                    );
                }}
                loadingRender={() => <Loading />}
            />
        </Container>
    );
};
